import { Box, useMediaQuery } from "@chakra-ui/react";

import { WarningWidget } from "components/Widgets";
import { ChakraText } from "components/ChakraText";

import { useGetPaginatedUserAppointments } from "../../../infrastructure/useGetPaginatedUserAppointments";
import { AppointmentsTable } from "./ActualAppointmentsTable";
import { ActualAppointmentsMobile } from "./ActualAppointmentsMobile";

const ActualAppointments = () => {
  const [isMobile] = useMediaQuery("(max-width: 967px)");
  const limit = 6;
  const { data } = useGetPaginatedUserAppointments({
    limit: limit,
    offset: 0,
  });

  if (!data) {
    return <></>;
  }

  if (data.total === 0) {
    return (
      <WarningWidget>
        <ChakraText fontSize={{ base: "xl", md: "2xl" }} alignSelf="center">
          Brak umówionych wizyt
        </ChakraText>
      </WarningWidget>
    );
  }

  return (
    <Box mt={4}>
      {isMobile ? (
        <ActualAppointmentsMobile
          totalAppointments={data.total}
          limit={limit}
        />
      ) : (
        <AppointmentsTable totalAppointments={data.total} limit={limit} />
      )}
    </Box>
  );
};

export { ActualAppointments };
